import { TouringCardActions } from '@common';

type RootPropsType = {
  children?: React.ReactNode;
};

export const Root: React.FC<RootPropsType> = ({ children }) => {
  return <TouringCardActions>{children}</TouringCardActions>;
};
